/**
 * AI 生文- 删除会话
 * @returns
 */
import { selectUser } from "@/reducer/userslice";
import { useCreateMsUserMutation, useLazyGetMSUserAllQuery, useLazyGetMsUserByToIdQuery } from "@/services/api/endpoints/msuser";
import { deleteChat } from "@/services/api/thunks/chat";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { MsUser } from "@/types/msuser";
import { ChatTopic } from "@/types/writing";
import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import PrivateLetterItem from "../messageCenter/privateLetterItem";
import MySessionItem from "./mySessionItem";
import OtherSessionItem from "./otherSessionItem";
import SendComponent from "./sendComponent";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  curUserId: string;
};

const PrivateLetterModal = (props: Props) => {
  const { isOpen, onClose, curUserId } = props;
  const toast = useToast();
  const user = useAppSelector(selectUser);
  const chatListRef = useRef<HTMLDivElement>(null)
  const [currentLetterUserId, setCurrentLetterUserId] = useState<string>(curUserId);

  const [getMsUserByToId, { data: privateLetter }] = useLazyGetMsUserByToIdQuery();
  const [GetMSUserAll, { data: chatList }] = useLazyGetMSUserAllQuery();
  const [createMsUser] = useCreateMsUserMutation();

  const currentLetterUser = privateLetter?.filter(item => item.form_id === currentLetterUserId)[0];

  useEffect(()=>{
    if(isOpen){
      getMsUserByToId({ user_id: currentLetterUserId });
      GetMSUserAll({ user_id: user.id, from_id: currentLetterUserId })
    }
  },[isOpen])

  const handClickMsuser = (item:MsUser)=>{
    setCurrentLetterUserId(item.form_id);
  }

  const handleSubmit = async (content: string) => {
    if (!user) {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
      return;
    }
    const result = await createMsUser({ from_id: user.id, to_id: currentLetterUserId, content: content })

  };
  
  useEffect(() => {
    const current = chatListRef.current
    if(current){
      console.log(current.scrollHeight, '137');    /*打印出来是监听的页面高度*/
    //scrollHeight是页面的高度
    current.scrollTop = current.scrollHeight
    }
    
  }, [chatList])


  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent bg="#fff">
        <Flex height={"80vh"} pt="15px" pb="15px">
          <Box w={"240px"} h="100%" borderRight="1px solid #DCE0EB">
            <Flex h="100%" flexDirection={"column"}>
              <Box
                h="40px"
                fontSize={"14px"}
                m="0 15px"
                p="0 15px 15px"
                color="#27314D"
                boxSizing="border-box"
                fontWeight={500}
                lineHeight="25px"
                borderBottom="1px solid #DCE0EB"
              >
                私信（20）
              </Box>
              <Box w="100%" flex={1} h="0" overflow={"auto"}>
                {privateLetter && privateLetter.map((item, index) => {
                  return (
                    <Box key={index}>
                      <PrivateLetterItem
                        isActive={currentLetterUserId === item.form_id}
                        letter={item}
                        handClickMsuser={handClickMsuser}
                      />
                    </Box>
                  );
                })}
              </Box>
            </Flex>
          </Box>
          <Box flex={1} h="100%">
            <Flex h="100%" flexDirection={"column"}>
              <Flex
                h="40px"
                fontSize={"14px"}
                m="0 15px"
                p="0 15px 15px"
                color="#27314D"
                boxSizing="border-box"
                fontWeight={500}
                lineHeight="25px"
                borderBottom="1px solid #DCE0EB"
              >
                <Box>{currentLetterUser?.from_user.user_name}</Box>
                <ModalCloseButton color={"#B9B9B9"} />
              </Flex>
              <Box flex={1} mt="15px" mb="15px" h="0" pl="30px" pr="30px" overflow={"auto"} ref={chatListRef}>
                {chatList && chatList.map((item, index)=> {
                  return (
                    <Box key={index}>
                      {item.form_id === user.id && item.to_id === currentLetterUserId && <MySessionItem sessionContent={item} />}
                      {item.form_id === currentLetterUserId && item.to_id === user.id && <OtherSessionItem sessionContent={item} />}
                    </Box>
                  )
                })}

              </Box>
              <Box pl="30px" pr="30px">
                <SendComponent
                  // text={text}
                  // updateValue={updateValue}
                  handleSubmit={handleSubmit}
                />
              </Box>
            </Flex>
          </Box>
        </Flex>
      </ModalContent>
    </Modal>
  );
};

export default PrivateLetterModal;
